import { EventFormatted, EventType, TagEvent } from './types';
import { Dispatch } from 'react';
import { DISABLED_COOKIES } from '../shared/constants';
import { AccountDataTest } from '../shared/tag/serializedTagTypes';

const ABTASTY_QA = 'ABTastyQA';

export const formatEvent = (
  e: TagEvent,
  accountDataTests: { [id: number]: AccountDataTest }
): EventFormatted | false => {
  if (e.type !== EventType.EVENT) return false;
  return Object.entries(e).reduce((acc, [key, value]) => {
    switch (key) {
      case 'qt':
        return { ...acc, triggered: value };
      case 'caid':
        return value ? { ...acc, campaignId: value, campaignName: accountDataTests[+value]?.name } : acc;
      case 'type': {
        if (!value || typeof value !== 'string') return acc;
        return {
          ...acc,
          type: e.ec || value.toLocaleLowerCase(),
          name: e.ea || value.toLocaleLowerCase(),
        };
      }
      case 'path':
        return { ...acc, path: value };
      default:
        return acc;
    }
  }, {}) as EventFormatted;
};

export const getTypeToDisplay = (e: TagEvent): EventType | 'Action Tracking' => {
  return e.ec || e.type;
};

export const addEventToStorage = (events: EventFormatted[]): void => {
  window.sessionStorage.setItem(ABTASTY_QA, JSON.stringify(events));
};

export const addEvent = (eventFormatted: EventFormatted): EventFormatted[] => {
  const collection = getEventsFromStorage();
  const events = [eventFormatted, ...collection];
  addEventToStorage(events);
  return events;
};

export const getEventsFromStorage = (): EventFormatted[] => {
  try {
    const data = window.sessionStorage.getItem(ABTASTY_QA);
    return data ? JSON.parse(data) : [];
  } catch (e) {
    console.error(e);
    throw Error(DISABLED_COOKIES);
  }
};

export const clearHistory = (callback: Dispatch<EventFormatted[]>) => {
  window.sessionStorage.setItem(ABTASTY_QA, JSON.stringify([]));
  callback([]);
};
